<template>
  <div v-if="order"> 
    <div class="d-flex align-items-center mb-2">
      <b-button variant="outline-secondary" class="btn-icon rounded-circle mr-1" @click="$router.back()">
        <feather-icon icon="ChevronLeftIcon" size="20" />
      </b-button>
      <h4 class="mb-0">Sipariş Detayı</h4>
    </div>

    <b-card class="mb-2">
      <div class="row text-center text-md-left justify-content-between align-items-center">
        <div class="col-md-3 mb-1 mb-md-0">
          <p class="card-text text-muted mb-50">Sipariş Tarihi</p>
          <h5 class="mb-0">{{ order.SiparisTarihi | formatDate }}</h5>
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
          <p class="card-text text-muted mb-50">Sipariş No</p>
          <h5 class="mb-0">{{ order.SiparisNo }}</h5>
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
          <p class="card-text text-muted mb-50">Sipariş Kaynağı</p>
          <h5 class="mb-0">{{ order.SiparisKaynagi }}</h5>
        </div>
        <div class="col-md-3">
          <p class="card-text text-muted mb-50">Sipariş Özeti</p>
          <h5 class="mb-0">{{ order.Urunler.length }} Kalem Ürün</h5>
        </div>
      </div>
    </b-card>

    <div class="row align-items-stretch">
      <div class="col-lg-8 d-flex flex-column">
        <b-card class="mb-2" title="Sipariş Durumu">
           <h5 class="text-success">{{ order.SiparisDurumu }}</h5>
        </b-card>

        <b-card no-body class="flex-fill mb-0">
            <h5 class="card-header">Sipariş Edilen Ürünler</h5>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>STOK KODU</th>
                            <th>ÜRÜN ADI</th> 
                            <th class="text-right">MİKTAR</th>
                            <th class="text-right">BİRİM FİYAT</th>
                            <th class="text-right">KDV</th>
                            <th class="text-right">TUTAR</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in order.Urunler" :key="item.UrunId">
                            <td>{{ item.StockCode }}</td>
                            <td>{{ item.StockName }}</td>
                            <td class="text-right">{{ item.Quantity }}</td>
                            <td class="text-right">{{ item.Tutar }}</td>
                            <td class="text-right">{{ item.KdvTutari * item.Quantity | formatPrice }} </td>
                            <td class="text-right font-weight-bold">{{ item.Tutar * item.Quantity | formatPrice }} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-card>
      </div>

      <div class="col-lg-4 d-flex flex-column">
          <b-card title="Teslimat Bilgileri" class="mb-2">
              <h6 class="mb-0">{{ order.UyeAdi }} {{ order.UyeSoyadi }}</h6>
              </b-card>

          <b-card title="Ödeme Özeti" class="flex-fill mb-0">
              <div class="d-flex justify-content-between">
                  <span class="text-muted">Ara Toplam</span>
                  <span>{{ order.ToplamTutar | formatPrice }} </span>
              </div>
              <div class="d-flex justify-content-between">
                  <span class="text-muted">KDV</span>
                  <span>{{ order.ToplamKdv | formatPrice }} </span>
              </div>
              <div v-if="order.IndirimTutari > 0" class="d-flex justify-content-between">
                  <span class="text-muted">İndirim Tutarı</span>
                  <span class="text-danger">- {{ order.IndirimTutari | formatPrice }} </span>
              </div>
              <hr>
              <div class="d-flex justify-content-between font-weight-bold">
                  <span>TOPLAM</span>
                  <span>{{ order.SiparisToplamTutari | formatPrice }} </span>
              </div>
          </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard, BButton, BRow, BCol } from 'bootstrap-vue'
import { B2BOrderApi } from '@/api/b2b-order'

export default {
  components: {
    BCard, BButton, BRow, BCol
  },
  data() {
    return {
      order: null, 
      loading: false,
    }
  },
  props: {
    orderData: {
      type: Object, 
      default: null
    }
  },
  created() {
     if (this.orderData) {
      this.order = this.orderData;
    } else {
      this.$router.push({ name: 'b2b-orders' });
    }
  },
  methods: {
    
  },
  filters: {
    formatDate(value) {
      if (!value) return '';
      return new Date(value).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    },
    formatPrice(value) {
      if (typeof value !== 'number') return value;
      return value.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
    }
  },
}
</script>

<style scoped>
.card-title {
  margin-bottom: 1rem;
}
</style>